import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { NativeSelect } from '@/components/ui/native-select'
import { ufChoice } from '@/lib/deadlines'
import * as toast from '@/lib/toast'
import { deadlineService, type DeadlineRecord, type DeadlineUnit } from '@/services/deadline-service'
import type { DeadlinePublication } from './PublicationDeadlinePanel'

/** Lança um prazo sugerido à mão para a publicação (o cálculo é do servidor). */
export function ManualDeadlineForm({ publication, onCreated }: { publication: DeadlinePublication; onCreated: (r: DeadlineRecord) => void }) {
  const choice = ufChoice(publication.siglaTribunal)
  const [dias, setDias] = useState('15')
  const [unidade, setUnidade] = useState<DeadlineUnit>('UTEIS')
  const [uf, setUf] = useState(choice?.fixed ?? '')
  const [busy, setBusy] = useState(false)

  if (!choice) {
    return <p className="text-xs text-muted-foreground">Tribunal {publication.siglaTribunal} sem calendário forense cadastrado: calcule o prazo manualmente.</p>
  }

  const submit = async (event: React.FormEvent) => {
    event.preventDefault()
    setBusy(true)
    try {
      onCreated(await deadlineService.createManual({
        tribunal: publication.siglaTribunal,
        uf: uf || null,
        disponibilizacao: publication.dataDisponibilizacao.slice(0, 10),
        dias: Number(dias),
        unidade,
        publicationId: publication.id,
        numeroProcesso: publication.numeroProcesso,
      }))
    } catch (error) {
      const message = (error as { response?: { data?: { error?: { message?: string } } } }).response?.data?.error?.message
      toast.error('Prazo não calculado', message ?? 'Erro ao calcular')
    } finally {
      setBusy(false)
    }
  }

  return (
    <form onSubmit={submit} className="flex flex-wrap items-end gap-2" aria-label="Calcular prazo">
      <div className="w-20">
        <Label htmlFor="prazo-dias" className="text-xs">Dias</Label>
        <Input id="prazo-dias" type="number" min={1} max={365} value={dias} onChange={(e) => setDias(e.target.value)} required />
      </div>
      <div className="w-36">
        <Label htmlFor="prazo-unidade" className="text-xs">Contagem</Label>
        <NativeSelect id="prazo-unidade" value={unidade} onChange={(e) => setUnidade(e.target.value as DeadlineUnit)}>
          <option value="UTEIS">Dias úteis</option>
          <option value="CORRIDOS">Dias corridos</option>
        </NativeSelect>
      </div>
      {!choice.fixed && (
        <div className="w-24">
          <Label htmlFor="prazo-uf" className="text-xs">UF</Label>
          <NativeSelect id="prazo-uf" value={uf} onChange={(e) => setUf(e.target.value)}>
            <option value="">—</option>
            {choice.options.map((u) => <option key={u} value={u}>{u}</option>)}
          </NativeSelect>
        </div>
      )}
      <Button type="submit" size="sm" loading={busy}>Calcular prazo</Button>
    </form>
  )
}
